/*
 * @Author: guodeyou
 * @Date: 2023-02-08 10:08:02
 * @LastEditors: guodeyou
 * @LastEditTime: 2023-08-17 13:27:31
 */
import { BsUtil } from 'dida-web-common'

let isFirstIn = true

export default function(router) {
  // 全局导航钩子
  router.beforeEach((to, from, next) => {
    if (isFirstIn) {
      isFirstIn = false
      const page = BsUtil.queryString('page')
      if (page) {
        return next({ name: page, replace: true })
      }
    }
    return next()
  })
}
